export const parseParam = <T>(paramValue: string | undefined | null, fallback: T): T => {
  if (!paramValue) {
    return fallback
  }
  if (typeof fallback === "number") {
    const parsed = parseInt(paramValue, 10)
    return (isNaN(parsed) ? fallback : parsed) as T
  }

  return paramValue as T
}
